import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';
import { Named } from '../base/named';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { ActionConstants } from '../../constants/action-constants';
import { ModelConstants } from '../model-constants';

@Metamodel.model({
    name: ModelConstants.integrationRuntime,
    display: [shellStringResources.IntegrationRuntime, shellStringResources.IntegrationRuntimes],
    referable: true,
    reusable: true,
    tags: {
        noValidationWhenReferenced: true
    },
    constraints: {
        name: {
            required: true,
            pattern: new RegExp('^[^-\\s][^\\\\/:*?"<>|]{1,140}$')
        }
    },
    accessPublishConstraint: {
        writeResource: {
            action: ActionConstants.integrationRuntimesWrite
        },
        deleteResource: {
            action: ActionConstants.integrationRuntimesDelete
        },
        readResource: {
            action: ActionConstants.integrationRuntimesRead
        }
    }
})
export class IntegrationRuntime extends Named {
    public static readonly MODEL: IModel;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
